<template>
    <!-- widget Tags -->
    <div class="widget widget-tags">
        <div class="widget-title">
            <h3>Info Kepegawaian</h3>
        </div>
        <div class="widget-body">
            <div v-for="news in newsList" :key="news.id" class="nav tag-cloud">
                <router-link :to="`/pengumuman/${news.id}`">{{ news.titel}}</router-link>
                
            </div>
        </div>
    </div>
    <!-- End widget Tags -->
</template>


<script>
import axios from "axios";

export default {
    name: "BeritaTerkini",
    data() {
        return {
            newsList: [],
            loading: true,
            error: null,
        };
    },
    methods: {
        async fetchNews() {
            try {
                const response = await axios.get(
                    "/content/pengumuman?pages=1&limit=3"
                );
                this.newsList = response.data.data;
                // console.log(response.data)
            } catch (err) {
                this.error = "Gagal memuat berita. Coba lagi nanti.";
            } finally {
                this.loading = false;
            }
        },
        formatDate(date) {
            const options = { year: "numeric", month: "long", day: "numeric" };
            return new Date(date).toLocaleDateString("id-ID", options);
        },
    },
    created() {
        this.fetchNews();
    },
};
</script>
